import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

// The page-title "i" dot. Desktop: a 17px circle that toggles a 290px popover.
// Mobile: a 44px tap target opening a bottom sheet. Copy is verbatim from the
// design source and identical across both platforms.
const INFO_COPY =
  "Your personal shortlists. Save any player from their profile; only you see your radar.";

const RadarInfoDot = ({ mobile = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open || mobile) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open, mobile]);

  if (mobile) {
    return (
      <>
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="About Radar"
          className="w-11 h-11 border-none bg-transparent cursor-pointer flex items-center justify-center p-0"
        >
          <span
            className="flex items-center justify-center"
            style={{
              width: 18,
              height: 18,
              borderRadius: "50%",
              border: "1px solid #C7D0DC",
              background: "#FFFFFF",
              color: "#6B7280",
              fontSize: 10.5,
              fontWeight: 700,
              fontStyle: "italic",
              fontFamily: "Georgia, serif",
            }}
          >
            i
          </span>
        </button>
        {open &&
          createPortal(
            <div className="fixed inset-0 z-[70] flex items-end" role="dialog" aria-modal="true">
              <div className="absolute inset-0 bg-[rgba(17,24,39,0.4)]" onClick={() => setOpen(false)} aria-hidden="true" />
              <div className="relative w-full bg-white rounded-t-[18px] px-5 pt-2 pb-10">
                <div className="w-9 h-1 rounded-full bg-[#DDE3EB] mx-auto mt-1 mb-3.5" aria-hidden="true" />
                <div className="text-[15px] font-bold text-[#111827] mb-1.5">Radar</div>
                <div className="text-[13.5px] text-[#374151] leading-[1.55] mb-4">{INFO_COPY}</div>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="w-full h-12 bg-[#2283FF] text-white border-none rounded-[9px] text-[14px] font-semibold cursor-pointer"
                >
                  Got it
                </button>
              </div>
            </div>,
            document.body,
          )}
      </>
    );
  }

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="About Radar"
        className="flex items-center justify-center cursor-pointer p-0"
        style={{
          width: 17,
          height: 17,
          borderRadius: "50%",
          border: "1px solid #C7D0DC",
          background: "#FFFFFF",
          color: "#6B7280",
          fontSize: 10,
          fontWeight: 700,
          fontStyle: "italic",
          fontFamily: "Georgia, serif",
        }}
      >
        i
      </button>
      {open && (
        <div
          className="absolute z-50"
          style={{
            left: 0,
            top: 26,
            width: 290,
            background: "#FFFFFF",
            border: "1px solid #E4E9F0",
            borderRadius: 9,
            boxShadow: "0 12px 32px rgba(17,24,39,0.14)",
            padding: "12px 14px",
            fontSize: 12.5,
            lineHeight: 1.5,
            color: "#374151",
          }}
        >
          {INFO_COPY}
        </div>
      )}
    </div>
  );
};

export default RadarInfoDot;
